module.exports = __webpack_public_path__ + "bb03b9140915069c41480b60e02b423f.svg";